import { useLogto } from '@logto/react';
import { Navigate, Outlet } from 'react-router';
import { Box, Typography, CircularProgress } from '@mui/material';

const RequireAuth = () => {
  const { isAuthenticated, isLoading } = useLogto();

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 4 }}>
        <CircularProgress />
        <Typography variant="body1" sx={{ ml: 2 }}>
          Loading authentication...
        </Typography>
      </Box>
    );
  }

  if (!isAuthenticated) {
    console.log('Not authenticated, redirecting to /info');
    return <Navigate to="/info" replace />;
  }

  // Render protected children
  console.log('Authenticated, rendering protected content');
  return (
    <Box sx={{ width: '100%' }}>
      <Outlet />
    </Box>
  );
};

export const ProtectedLoginRoute = ({children, isAuthenticated, isLoading, user}) => {
    // Show loading while checking authentication
    if (isLoading) {
        return <div>Loading...</div>;
    }

    // If user is authenticated, redirect them away from login page
    if (isAuthenticated) {
        const userRoles = user?.roles || [];
        const isStudent = userRoles.includes("student");
        const isTeacher = userRoles.includes("teacher");

        if (isStudent) {
            return <Navigate to="/student/dashboard" replace/>;
        }
        if (isTeacher) {
            return <Navigate to="/teacher/dashboard" replace/>;
        }

        // Fallback for authenticated users without clear roles
        return <Navigate to="/teacher/dashboard" replace/>;
    }

    // User is not authenticated, show the login page
    return children;
};

export default RequireAuth;